import React from 'react';

type AidaFormsLogoProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
};

/** Alturas de header: cabem na barra sem estourar o padding vertical. */
const sizeMap: Record<NonNullable<AidaFormsLogoProps['size']>, string> = {
  xs: 'h-5',
  sm: 'h-6',
  md: 'h-7',
  lg: 'h-8',
  xl: 'h-10',
};

/** Caminho do asset oficial, sem alteração de geometria nem de cor. */
const T_MARK = '/assets/t-systems-t.svg';
const WORDMARK = '/assets/t-systems.svg';

/**
 * Logo oficial da T-Systems (lockup T + wordmark, `t-systems.svg` copiado
 * verbatim para `public/assets/`). Usado no header, no lugar do texto
 * "AIDA Forms": a marca da empresa é a assinatura.
 *
 * Não redesenhe o path: o arquivo oficial é a fonte da verdade. A cor
 * `#e20074` vem do próprio SVG (mesma do token `--aida-pink`).
 */
export const AidaFormsLogo: React.FC<AidaFormsLogoProps> = ({ size = 'md', className = '' }) => (
  <img src={WORDMARK} alt="T-Systems" className={`w-auto ${sizeMap[size]} ${className}`} />
);

/** Só o símbolo T original, sem o nome. */
export const AidaFormsMark: React.FC<AidaFormsLogoProps> = ({ size = 'md', className = '' }) => (
  <img src={T_MARK} alt="T-Systems" className={`w-auto ${sizeMap[size]} ${className}`} />
);

/** Wordmark horizontal oficial "T-Systems". */
export const AidaFormsWordmark: React.FC<AidaFormsLogoProps> = ({ size = 'md', className = '' }) => (
  <img src={WORDMARK} alt="T-Systems" className={`w-auto ${sizeMap[size]} ${className}`} />
);

/** @deprecated usar `AidaFormsLogo`. Mantido para não quebrar imports antigos. */
export const MakeStudioLogo = AidaFormsLogo;

export default AidaFormsLogo;
